{
  "accountBlocked": "Account is blocked",
  "accountInactive": "Account is inactive",
  "alreadyHaveAccount": "Already have an account?",
  "backToLogin": "Back to Login",
  "backupCode": "Backup Code",
  "confirmPassword": "Confirm Password",
  "continue": "Continue",
  "createAccount": "Create Account",
  "creatingAccount": "Creating account...",
  "dontHaveAccount": "Don't have an account?",
  "email": "Email",
  "emailAddress": "Email Address",
  "emailAlreadyExists": "Email already exists",
  "emailNotVerified": "Email is not verified",
  "enter2FACode": "Enter 6-digit authentication code",
  "forgotPassword": "Forgot Password",
  "invalid2FACode": "Invalid authentication code",
  "invalidCredentials": "Invalid email or password",
  "loggingIn": "Logging in...",
  "login": "Login",
  "loginNow": "Login Now",
  "loginProtected": "Your account is protected by Google Authenticator.",
  "loginRequired": "Please log in to create a price alert.",
  "loginSuccessful": "Login successful",
  "logout": "Logout",
  "password": "Password",
  "pleaseWait": "Please wait...",
  "rememberMe": "Remember Me",
  "resetPassword": "Reset Password",
  "sendCode": "Send Code",
  "sending": "Sending...",
  "sessionExpired": "Session expired. Please login again.",
  "signup": "Sign Up",
  "signupNow": "Sign Up Now",
  "signupSuccessful": "Account created successfully",
  "twoFactorAuthentication": "Two-Factor Authentication",
  "verify": "Verify",
  "verify2FA": "Verify 2FA",
  "verifyEmail": "Verify Email",
  "verifyResetCode": "Verify Reset Code"
}